import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { UIService } from '../shared/ui.service';
import { MissingFieldsService } from './missing-fields.service';
import { getmissFieldsRes, ProcessRun } from './missifelds';

@Component({
  selector: 'app-missing-fields',
  templateUrl: './missing-fields.component.html',
  styleUrls: ['./missing-fields.component.css']
})
export class MissingFieldsComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private prs: MissingFieldsService, public uis: UIService) {
  }
  get_missFields() {
    this.isLoading = true;
    this.prs.get_missFields({}).subscribe((r: getmissFieldsRes) => {
      this.isLoading = false;

      console.log(r)
      this.alldata = r.processRuns.filter((e) => {
        return e.missingFieldCount > 0
      })
      this.dataSource.data = this.alldata;
      //let obk = r.processRuns[0];
      //let arr: ProcessRun[] = [];
      //for (let i = 0; i < 101; i++) {
      //  arr.push(obk);
      //}
      //this.dataSource.data = arr;
    }, (er) => {
      //console.log(er)
      this.isLoading = false;

    })
  }
  ngOnInit(): void {
    this.dataSource.paginator = this.paginator;
    this.get_missFields();

  }
  isLoading: boolean = false;
  getStatus() {
    if (this.isLoading) {
      return 'load';
    } else if (!this.isLoading && this.dataSource.data.length == 0) {
      return 'nf';
    }
  }
  displayedColumns: string[] = ['p_id', 'sdate', 'edate', 'status', 'dload'];
  dataSource = new MatTableDataSource<ProcessRun>();
  alldata: ProcessRun[] = [];

  getMissFields(p_id, count) {
    if (count && count > 0) {


      this.prs.getMissingFieldsReport(p_id).subscribe((r: any) => {
        console.log(r)
        if (r.status == 400 || r.statusCode == 404 || r.body.type != "text/csv") {
          this.uis.showSnackbar("No Missing Fields Found", "Ok", 2000, false)
          return 1;
        }
        let blob: Blob = r.body as Blob;
        const a = document.createElement("a");
        a.href = window.URL.createObjectURL(blob);
        let filename = "MissingFields";
        a.setAttribute("download", filename + ".csv");
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

      }, (er) => {
        this.uis.showSnackbar("No Missing Fields Found", "Ok", 2000, false)
      })
    } else {
      this.uis.showSnackbar("No Missing Fields Found", "Ok", 2000, false);
    }
  }

  resetFilters() {
    this.dataSource.data = this.alldata;
    this.dates = null;
  }
  dates: any;
  getDateinMili(e) {
    //console.log(e)
    let d = new Date(e).getDate().toString();
    let m = (new Date(e).getMonth() + 1).toString();
    let y = new Date(e).getFullYear().toString();
    //let time: any = d + "-" + m + "-" + y;
    let time: any = y + "-" + m + "-" + d;
    //console.log(time)
    time = new Date(time).getTime();
    //console.log(time)
    return time;
  }

  changeSate(e) {
    let today = e.value;
    today = this.getDateinMili(e.value);
    //console.log(today)

    let a: ProcessRun[] = this.alldata.filter((e) => {
      //console.log(today, this.getDateinMili(e.endTime))
      return today == this.getDateinMili(e.endTime);
    })
    //console.log(a)
    this.dataSource.data = a;


  }

}
